module.exports = __webpack_public_path__ + "img/404icon.2dbbecb3.svg";